webpackJsonp([0],{

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(360);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.clubSiteAdmin = window.clubSiteAdmin || {};
window.$ = window.jQuery = _jquery2.default;

/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(fetch) {

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(360);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(31);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(440);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(529);

var _createBrowserHistory = __webpack_require__(531);

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global fetch */


window.clubSiteAdmin.resultsInit = function () {
	var Loader = function (_React$Component) {
		_inherits(Loader, _React$Component);

		function Loader() {
			_classCallCheck(this, Loader);

			return _possibleConstructorReturn(this, (Loader.__proto__ || Object.getPrototypeOf(Loader)).apply(this, arguments));
		}

		_createClass(Loader, [{
			key: 'render',
			value: function render() {
				return React.createElement(
					'div',
					{ className: 'col-md-10' },
					React.createElement(
						'div',
						{ className: 'spinner' },
						React.createElement(
							'h1',
							{ className: 'no-margin-top' },
							React.createElement(
								'small',
								null,
								'Loading...'
							)
						),
						React.createElement('img', { src: '/images/spinner.gif' })
					)
				);
			}
		}]);

		return Loader;
	}(React.Component);

	var ResultsMessage = function (_React$Component2) {
		_inherits(ResultsMessage, _React$Component2);

		function ResultsMessage() {
			_classCallCheck(this, ResultsMessage);

			return _possibleConstructorReturn(this, (ResultsMessage.__proto__ || Object.getPrototypeOf(ResultsMessage)).apply(this, arguments));
		}

		_createClass(ResultsMessage, [{
			key: 'render',
			value: function render() {
				return React.createElement(
					'div',
					{ className: 'col-md-10' },
					React.createElement(
						'h3',
						{ className: 'text-muted no-margin-top' },
						this.props.text
					)
				);
			}
		}]);

		return ResultsMessage;
	}(React.Component);

	var EventResult = function (_React$Component3) {
		_inherits(EventResult, _React$Component3);

		function EventResult() {
			_classCallCheck(this, EventResult);

			return _possibleConstructorReturn(this, (EventResult.__proto__ || Object.getPrototypeOf(EventResult)).apply(this, arguments));
		}

		_createClass(EventResult, [{
			key: 'getHtml',
			value: function getHtml() {
				var resultHtml = this.props.data.html;
				return { __html: resultHtml };
			}
		}, {
			key: 'fullResultLink',
			value: function fullResultLink(url, linkText) {
				if (!url) {
					return null;
				}
				return React.createElement(
					'p',
					null,
					'View Full Results: ',
					React.createElement(
						'a',
						{ href: url, target: '_blank' },
						linkText
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var result = this.props.data;
				return React.createElement(
					'div',
					{ className: 'event-result' },
					React.createElement('a', { name: result.key }),
					React.createElement(
						'h3',
						null,
						result.name,
						React.createElement(
							'span',
							{ className: 'pull-right text-muted margin-left-md' },
							React.createElement(
								'small',
								null,
								result.date
							)
						)
					),
					this.fullResultLink(result.url, result.linkText),
					React.createElement('div', { className: 'table-responsive wysiwyg-content', dangerouslySetInnerHTML: this.getHtml() })
				);
			}
		}]);

		return EventResult;
	}(React.Component);

	var ResultsMenu = function (_React$Component4) {
		_inherits(ResultsMenu, _React$Component4);

		function ResultsMenu(props) {
			_classCallCheck(this, ResultsMenu);

			var _this4 = _possibleConstructorReturn(this, (ResultsMenu.__proto__ || Object.getPrototypeOf(ResultsMenu)).call(this, props));

			_this4.state = {
				menuData: JSON.parse((0, _jquery2.default)('#menu-data').val())
			};
			return _this4;
		}

		_createClass(ResultsMenu, [{
			key: 'renderMonths',
			value: function renderMonths(year) {
				return year.months.map(function (m) {
					var key = m.monthName + '/' + year.year;
					return React.createElement(
						_reactRouterDom.Link,
						{ key: key, to: '/results/' + key, className: 'list-group-item' },
						m.monthName
					);
				});
			}
		}, {
			key: 'renderYears',
			value: function renderYears() {
				var _this5 = this;

				return this.state.menuData.map(function (y) {
					var id = 'result-menu-year-' + y.year;
					if (!_this5.firstYear) {
						_this5.firstYear = id;
					}
					return React.createElement(
						'div',
						{ key: y.year },
						React.createElement(
							'a',
							{ href: '#item-' + y.year, id: id, className: 'list-group-item', 'data-toggle': 'collapse' },
							React.createElement('i', { className: 'glyphicon glyphicon-chevron-right' }),
							React.createElement(
								'strong',
								null,
								y.year
							)
						),
						React.createElement(
							'div',
							{ className: 'list-group collapse', id: 'item-' + y.year },
							_this5.renderMonths(y)
						)
					);
				});
			}
		}, {
			key: 'render',
			value: function render() {
				if (!this.state.menuData.length) {
					return null;
				}
				return React.createElement(
					'div',
					{ className: 'col-md-2' },
					React.createElement(
						'h3',
						{ className: 'no-margin-top' },
						'Past Results'
					),
					React.createElement(
						'div',
						{ className: 'list-group list-group-root well', id: 'results-menu' },
						this.renderYears()
					)
				);
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				(0, _jquery2.default)('#' + this.firstYear).click();
			}
		}]);

		return ResultsMenu;
	}(React.Component);

	var ResultsContainer = function (_React$Component5) {
		_inherits(ResultsContainer, _React$Component5);

		function ResultsContainer() {
			_classCallCheck(this, ResultsContainer);

			return _possibleConstructorReturn(this, (ResultsContainer.__proto__ || Object.getPrototypeOf(ResultsContainer)).apply(this, arguments));
		}

		_createClass(ResultsContainer, [{
			key: 'render',
			value: function render() {
				var results = this.props.results;
				if (this.props.loading) {
					return React.createElement(Loader, null);
				}
				if (results.items.length) {
					var eventResultNodes = results.items.map(function (r) {
						return React.createElement(EventResult, { data: r, key: r.key });
					});
					return React.createElement(
						'div',
						{ className: 'col-md-10' },
						React.createElement(
							'h2',
							{ className: 'no-margin-top' },
							results.displayMonth,
							' ',
							results.displayYear
						),
						eventResultNodes
					);
				} else {
					return React.createElement(ResultsMessage, { text: 'There are no results for this date.' });
				}
			}
		}]);

		return ResultsContainer;
	}(React.Component);

	var ResultsPage = function (_React$Component6) {
		_inherits(ResultsPage, _React$Component6);

		function ResultsPage(props) {
			_classCallCheck(this, ResultsPage);

			var _this7 = _possibleConstructorReturn(this, (ResultsPage.__proto__ || Object.getPrototypeOf(ResultsPage)).call(this, props));

			if (props.defaultResults) {
				_this7.state = {
					results: props.defaultResults,
					loading: false
				};
				return _possibleConstructorReturn(_this7);
			}
			var p = props.match.params;
			_this7.updateData(p.month, p.year);
			_this7.state = {
				results: { items: [] },
				loading: true
			};
			return _this7;
		}
		// fakeItems: {
		//   items: [
		//       {
		//           key: 'a-race-test-13th-sept-2016',
		//           name: 'A Race {test2}',
		//           html: '<p>blah blah results</p>',
		//           date: 'Sunday 13th September 2015'
		//       }, {
		//           key: 'some-other-race-5th-sept-2016',
		//           name: 'Some Other Race {test}',
		//           html: '<p>info stuff</p>',
		//           date: 'Saturday 5th September 2015'
		//       }
		//   ],
		//   displayMonth: 'FAKE API MONTH',
		//   displayYear: '2015'
		// }


		_createClass(ResultsPage, [{
			key: 'getApiResults',
			value: function getApiResults(month, year) {
				var _this8 = this;

				var url = '/api/results/' + month + '/' + year;
				/* console.log("url = ", url);*/
				fetch(url).then(function (response) {
					if (response.ok) {
						return response;
					}
					return response.text().then(function (body) {
						var error = new Error(response.statusText);
						error.responseBody = body;
						throw error;
					});
				}).then(function (res) {
					return res.json();
				}).then(function (data) {
					_this8.setState({
						results: data,
						loading: false
					});
					window.scrollTo(0, 0);
				}).catch(function (err) {
					console.log(err.message + ': ' + err.responseBody);
					_this8.setState({
						results: { items: [] },
						loading: false
					});
					window.scrollTo(0, 0);
				});
			}
		}, {
			key: 'updateData',
			value: function updateData(month, year) {
				if (month !== undefined && year !== undefined) {
					this.getApiResults(month, year);
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var p = this.props.match.params;
				var np = nextProps.match.params;
				if (p.month !== np.month || p.year !== np.year) {
					this.setState({ loading: true });
					this.updateData(np.month, np.year);
				}
			}
			//TODO: get this working... https://github.com/ReactTraining/react-router/issues/394
			/* setAnchorScrollingBehaviour() {
    *   // Decode entities in the URL
    *   // Sometimes a URL like #/foo#bar will be encoded as #/foo%23bar
    *   window.location.hash = window.decodeURIComponent(window.location.hash);
    *   const scrollToAnchor = () => {
    *     const hashParts = window.location.hash.split('#');
    *     if (hashParts.length > 2) {
    *       const hash = hashParts.slice(-1)[0];
    *       document.querySelector(`#${hash}`).scrollIntoView();
    *     }
    *   };
    *   scrollToAnchor();
    *   window.onhashchange = scrollToAnchor;
    * }
    * componentDidMount() {
    *   this.setAnchorScrollingBehaviour();
    * }
    * componentDidUdpate() {
    *   this.setAnchorScrollingBehaviour();
    * }*/

		}, {
			key: 'render',
			value: function render() {
				return React.createElement(
					'div',
					{ className: 'row' },
					React.createElement(ResultsContainer, { results: this.state.results, loading: this.state.loading }),
					React.createElement(ResultsMenu, null)
				);
			}
		}]);

		return ResultsPage;
	}(React.Component);

	// Allows us to set/access route props in router v4
	// https://github.com/ReactTraining/react-router/issues/4105#issuecomment-289195202


	var renderMergedProps = function renderMergedProps(component) {
		for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
			rest[_key - 1] = arguments[_key];
		}

		var finalProps = Object.assign.apply(Object, [{}].concat(rest));
		return React.createElement(component, finalProps);
	};

	var PropsRoute = function PropsRoute(_ref) {
		var component = _ref.component,
		    rest = _objectWithoutProperties(_ref, ['component']);

		return React.createElement(_reactRouterDom.Route, _extends({}, rest, { render: function render(routeProps) {
				return renderMergedProps(component, routeProps, rest);
			} }));
	};

	var mostRecentResults = JSON.parse((0, _jquery2.default)('#result-data').val());
	var browserHistory = (0, _createBrowserHistory2.default)();

	_reactDom2.default.render(React.createElement(
		_reactRouterDom.BrowserRouter,
		{ history: browserHistory },
		React.createElement(
			_reactRouterDom.Switch,
			null,
			React.createElement(_reactRouterDom.Route, { exact: true, path: '/results/:month/:year', component: ResultsPage }),
			React.createElement(PropsRoute, { exact: true, path: '/results', component: ResultsPage, defaultResults: mostRecentResults })
		)
	), document.getElementById('results-page'));
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(327)))

/***/ }),

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(142);
__webpack_require__(325);
module.exports = __webpack_require__(362);


/***/ }),

/***/ 362:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _modernizr = __webpack_require__(545);

var _modernizr2 = _interopRequireDefault(_modernizr);

__webpack_require__(363);

__webpack_require__(326);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (typeof clubSiteAdmin.init === 'function') {
	clubSiteAdmin.init();
} /* global clubSiteAdmin */

/***/ }),

/***/ 363:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(360);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(366);

__webpack_require__(364);

__webpack_require__(365);

__webpack_require__(544);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// collapsable list group icon behaviour
(0, _jquery2.default)('.list-group-item').on('click', function () {
		(0, _jquery2.default)('.glyphicon', this).toggleClass('glyphicon-chevron-right').toggleClass('glyphicon-chevron-down');
});

// extended menu behaviour
(0, _jquery2.default)('#main-menu').smartmenus();

// media lightboxes
(0, _jquery2.default)(document).on('click', '[data-toggle="lightbox"]', function (event) {
		event.preventDefault();
		(0, _jquery2.default)(this).ekkoLightbox({
				// alwaysShowClose: true
		});
});

/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (window) {
  var hadGlobal = 'Modernizr' in window;var oldGlobal = window.Modernizr; /*!
                                                                          * modernizr v3.5.0
                                                                          * Build https://modernizr.com/download?-rgba-setclasses-dontmin
                                                                          *
                                                                          * Copyright (c)
                                                                          *  Faruk Ates
                                                                          *  Paul Irish
                                                                          *  Alex Sexton
                                                                          *  Ryan Seddon
                                                                          *  Patrick Kettner
                                                                          *  Stu Cox
                                                                          *  Richard Herrera
                                                                          * MIT License
                                                                          */

  /*
   * Modernizr tests which native CSS3 and HTML5 features are available in the
   * current UA and makes the results available to you in two ways: as properties on
   * a global `Modernizr` object, and as classes on the `<html>` element. This
   * information allows you to progressively enhance your pages with a granular level
   * of control over the experience.
  */

  ;(function (window, document, undefined) {
    var tests = [];

    /**
     *
     * ModernizrProto is the constructor for Modernizr
     *
     * @class
     * @access public
     */

    var ModernizrProto = {
      // The current version, dummy
      _version: '3.5.0',

      // Any settings that don't work as separate modules
      // can go in here as configuration.
      _config: {
        'classPrefix': '',
        'enableClasses': true,
        'enableJSClass': true,
        'usePrefixes': true
      },

      // Queue of tests
      _q: [],

      // Stub these for people who are listening
      on: function on(test, cb) {
        // I don't really think people should do this, but we can
        // safe guard it a bit.
        // -- NOTE:: this gets WAY overridden in src/addTest for actual async tests.
        // This is in case people listen to synchronous tests. I would leave it out,
        // but the code to *disallow* sync tests in the real version of this
        // function is actually larger than this.
        var self = this;
        setTimeout(function () {
          cb(self[test]);
        }, 0);
      },

      addTest: function addTest(name, fn, options) {
        tests.push({ name: name, fn: fn, options: options });
      },

      addAsyncTest: function addAsyncTest(fn) {
        tests.push({ name: null, fn: fn });
      }
    };

    // Fake some of Object.create so we can force non test results to be non "own" properties.
    var Modernizr = function Modernizr() {};
    Modernizr.prototype = ModernizrProto;

    // Leak modernizr globally when you `require` it rather than force it here.
    // Overwrite name so constructor name is nicer :D
    Modernizr = new Modernizr();

    var classes = [];

    /**
     * is returns a boolean if the typeof an obj is exactly type.
     *
     * @access private
     * @function is
     * @param {*} obj - A thing we want to check the type of
     * @param {string} type - A string to compare the typeof against
     * @returns {boolean}
     */

    function is(obj, type) {
      return (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === type;
    }
    ;

    /**
     * Run through all tests and detect their support in the current UA.
     *
     * @access private
     */

    function testRunner() {
      var featureNames;
      var feature;
      var aliasIdx;
      var result;
      var nameIdx;
      var featureName;
      var featureNameSplit;

      for (var featureIdx in tests) {
        if (tests.hasOwnProperty(featureIdx)) {
          featureNames = [];
          feature = tests[featureIdx];
          // run the test, throw the return value into the Modernizr,
          // then based on that boolean, define an appropriate className
          // and push it into an array of classes we'll join later.
          //
          // If there is no name, it's an 'async' test that is run,
          // but not directly added to the object. That should
          // be done with a post-run addTest call.
          if (feature.name) {
            featureNames.push(feature.name.toLowerCase());

            if (feature.options && feature.options.aliases && feature.options.aliases.length) {
              // Add all the aliases into the names list
              for (aliasIdx = 0; aliasIdx < feature.options.aliases.length; aliasIdx++) {
                featureNames.push(feature.options.aliases[aliasIdx].toLowerCase());
              }
            }
          }

          // Run the test, or use the raw value if it's not a function
          result = is(feature.fn, 'function') ? feature.fn() : feature.fn;

          // Set each of the names on the Modernizr object
          for (nameIdx = 0; nameIdx < featureNames.length; nameIdx++) {
            featureName = featureNames[nameIdx];
            // Support dot properties as sub tests. We don't do checking to make sure
            // that the implied parent tests have been added. You must call them in
            // order (either in the test, or make the parent test a dependency).
            //
            // Cap it to TWO to make the logic simple and because who needs that kind of subtesting
            // hashtag famous last words
            featureNameSplit = featureName.split('.');

            if (featureNameSplit.length === 1) {
              Modernizr[featureNameSplit[0]] = result;
            } else {
              // cast to a Boolean, if not one already
              if (Modernizr[featureNameSplit[0]] && !(Modernizr[featureNameSplit[0]] instanceof Boolean)) {
                Modernizr[featureNameSplit[0]] = new Boolean(Modernizr[featureNameSplit[0]]);
              }

              Modernizr[featureNameSplit[0]][featureNameSplit[1]] = result;
            }

            classes.push((result ? '' : 'no-') + featureNameSplit.join('-'));
          }
        }
      }
    }
    ;

    /**
     * docElement is a convenience wrapper to grab the root element of the document
     *
     * @access private
     * @returns {HTMLElement|SVGElement} The root element of the document
     */

    var docElement = document.documentElement;

    /**
     * A convenience helper to check if the document we are running in is an SVG document
     *
     * @access private
     * @returns {boolean}
     */

    var isSVG = docElement.nodeName.toLowerCase() === 'svg';

    /**
     * setClasses takes an array of class names and adds them to the root element
     *
     * @access private
     * @function setClasses
     * @param {string[]} classes - Array of class names
     */

    // Pass in an and array of class names, e.g.:
    //  ['no-webp', 'borderradius', ...]
    function setClasses(classes) {
      var className = docElement.className;
      var classPrefix = Modernizr._config.classPrefix || '';

      if (isSVG) {
        className = className.baseVal;
      }

      // Change `no-js` to `js` (independently of the `enableClasses` option)
      // Handle classPrefix on this too
      if (Modernizr._config.enableJSClass) {
        var reJS = new RegExp('(^|\\s)' + classPrefix + 'no-js(\\s|$)');
        className = className.replace(reJS, '$1' + classPrefix + 'js$2');
      }

      if (Modernizr._config.enableClasses) {
        // Add the new classes
        className += ' ' + classPrefix + classes.join(' ' + classPrefix);
        if (isSVG) {
          docElement.className.baseVal = className;
        } else {
          docElement.className = className;
        }
      }
    }

    ;

    /**
     * createElement is a convenience wrapper around document.createElement. Since we
     * use createElement all over the place, this allows for (slightly) smaller code
     * as well as abstracting away issues with creating elements in contexts other than
     * HTML documents (e.g. SVG documents).
     *
     * @access private
     * @function createElement
     * @returns {HTMLElement|SVGElement} An HTML or SVG element
     */

    function createElement() {
      if (typeof document.createElement !== 'function') {
        // This is the case in IE7, where the type of createElement is "object".
        // For this reason, we cannot call apply() as Object is not a Function.
        return document.createElement(arguments[0]);
      } else if (isSVG) {
        return document.createElementNS.call(document, 'http://www.w3.org/2000/svg', arguments[0]);
      } else {
        return document.createElement.apply(document, arguments);
      }
    }

    ;
    /*!
    {
      "name": "CSS rgba",
      "caniuse": "css3-colors",
      "property": "rgba",
      "tags": ["css"],
      "notes": [{
        "name": "CSSTricks Tutorial",
        "href": "https://css-tricks.com/rgba-browser-support/"
      }]
    }
    !*/

    Modernizr.addTest('rgba', function () {
      var style = createElement('a').style;
      style.cssText = 'background-color:rgba(150,255,150,.5)';

      return ('' + style.backgroundColor).indexOf('rgba') > -1;
    });

    // Run each test
    testRunner();

    // Remove the "no-js" class if it exists
    setClasses(classes);

    delete ModernizrProto.addTest;
    delete ModernizrProto.addAsyncTest;

    // Run the things that are supposed to run after the tests
    for (var i = 0; i < Modernizr._q.length; i++) {
      Modernizr._q[i]();
    }

    // Leak Modernizr namespace
    window.Modernizr = Modernizr;

    ;
  })(window, document);module.exports = window.Modernizr;if (hadGlobal) {
    window.Modernizr = oldGlobal;
  } else {
    delete window.Modernizr;
  }
})(window);

/***/ })

},[361]);


// WEBPACK FOOTER //
// app.prod.bundle.js